import React from 'react';
import { Col, Row, Statistic } from 'antd';
import CountUp from 'react-countup';

const formatter = (value) => (
  <span>
    <CountUp end={value} separator="," />+
  </span>
);

const statisticsData = [
  { title: "Students Trained", value: 1200 },
  // { title: "Expert Instructors", value: 152 },
  { title: "Courses", value: 10 },
  { title: "Training Hours", value: 800 },
  { title: "Placement Assistance", value: 400 },
];

const ActiveUsers1 = () => (
  <Row 
    gutter={[16, 16]} 
    justify="space-around" 
    style={{
      textAlign: 'center',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      padding: '40px',
      minHeight: '10vh',
    }}
  >
    {statisticsData.map((stat, index) => (
      <Col xs={24} sm={12} md={8} lg={4} key={index}>
        <div style={{ 
          height: '150px', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          alignItems: 'center',
          backgroundColor: 'gray',
          borderRadius: '8px',
          padding: '15px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        }}>
          <Statistic
            title={<span style={{ fontSize: '20px', fontWeight: 'bolder', color: 'white' }}>{stat.title}</span>} // Custom title with style
            value={stat.value}
            formatter={formatter}            
            valueStyle={{
              fontWeight: 'bold',
              color: '#B80000',
              fontSize: '24px', // Adjusted font size for value
            }}
          />
        </div>
      </Col>
    ))}
  </Row>
);

export default ActiveUsers1;
